module.exports = __webpack_public_path__ + "static/googleplay-5600fad6c8ba5318ac6a50fb996b2f32.svg";